module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門6_3.c38074de.png";